export * from './objects/types'
export * from './fields/types'
export * from './fields-groups/types'
export * from './comments/types'

export enum ValidationTypes {
  ADDRESS = 'address',
  EMAIL = 'email',
  PHONE = 'phone',
  SITE = 'site',
  DATETIME_FUTURE = 'datetime_future',
  DATETIME_PAST = 'datetime_past',
  REGEXP = 'regexp',
}

export enum ValueTypes {
  STRING = 'string',
  TEXT = 'text',
  INTEGER = 'integer',
  FLOAT = 'float',
  BOOLEAN = 'boolean',
  DATE = 'date',
  TIME = 'time',
  DATETIME = 'datetime',
  RELATIONSHIP = 'relationship',
  MEDIA = 'media',
  FORMULA = 'formula',
  USER = 'user',
  CURRENCY = 'currency',
  ADDRESS = 'address',
}

export enum MediaTypes {
  IMAGE = 'image',
  VIDEO = 'video',
  FILE = 'file',
}

export enum CommunicationTypes {
  EMAIL = 'email',
  PHONE = 'phone',
  // WHATSAPP = 'whatsapp',
  VIBER = 'viber',
  // TELEGRAM = 'telegram',
  FACEBOOK = 'facebook',
  X = 'x',
  SITE = 'site',
  LINKEDIN = 'linkedin',
}

export enum VisualStyles {
  DROPDOWN = 'dropdown',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  FLAT_LIST = 'flat_list',
  STAGE = 'stage',
}
export enum EShortPurpose {
  icon = 'icon',
  primary = 'primary',
  secondary = 'secondary',
}
export interface ISchemaChoice {
  createdAt: string
  fieldSchemeId: number
  id: number
  index: number
  isDeleted: boolean
  updatedAt: string
  value: string
  text: string
}
export enum ESchemaType {
  systemCreatedAt = 'system_created_at',
}
export interface ISchema {
  communicationType: `${CommunicationTypes}` | null
  createdAt: string
  fieldsGroupIdentifier: string
  formula: string | null
  hasChoices: boolean
  id: number | string
  identifier: string
  type: `${ESchemaType}`
  isDeleted: boolean
  defaultValue?: unknown
  isHidden: boolean
  isMultivalue: boolean
  isRequired: boolean
  mediaType: `${MediaTypes}` | null
  objectSchemeIdentifier: string
  placeholder: string | null
  readOnly: boolean
  relationshipObjectSchemeIdentifier: string | null
  showEmpty: boolean | null
  sortIndex: number
  title: string
  isNotificationEnabled: boolean
  shortPurpose?: `${EShortPurpose}` | null
  tooltip: string | null
  updatedAt: string | null
  validation: `${ValidationTypes}` | null
  validationRegexp: string | null
  valueType: `${ValueTypes}` | null
  visualStyle: `${VisualStyles}` | null
  choices?: ISchemaChoice[]

  usedForCommunication?: boolean | null
  usedForMail?: boolean | null
  usedForMailFirstName?: boolean | null
  usedForMailLastName?: boolean | null
}

export interface IFieldsOption {
  title: string
  slug: string
  icon: string
  schema: ISchemaProps
}

export type ISchemaProps = { [key in keyof ISchema]?: ISchema[key] }

export interface IGetSchemasParams {
  perPage?: number
  cursor?: string
  showInMenu?: boolean
  type?: `${ESchemeTypes}`
}

export interface IGetSingleSchema {
  objectScheme: string
  isAdmin?: boolean
}
export interface IPutSchemasParams {
  title: string
  identifier: string
  icon?: string
  frontDefaultView?: string
  type: `${ESchemeTypes}`
  showInMenu?: boolean
  parentObjectSchemeIdentifier?: string
  isParentObjectRequired?: boolean
}
export type IPutSchemasData = ISchemaInfo

export interface IPostSchemasParams {
  title: string
  icon?: string
  identifier: string
  frontDefaultView?: string
  showInMenu?: boolean
  type: `${ESchemeTypes}`
  parentObjectSchemeIdentifier?: string
  isParentObjectRequired?: boolean
}

export type IPostSchemasData = ISchemaInfo

export interface IDeleteSchemasParams {
  identifier: string
}
export type IDeleteSchemasData = ISchemaInfo

export enum EUserAbilities {
  show = 'show',
  update = 'update',
  destroy = 'destroy',
  createNewObjects = 'createNewObjects',
}

export enum ESchemeTypes {
  contact = 'contact',
  company = 'company',
  deal = 'deal',
  task = 'task',
  other = 'other',
}
export interface ISchemaInfo {
  children: Omit<ISchemaInfo, 'children'>[]
  frontDefaultView: string
  icon: string
  iconFieldSchemeIdentifier: string
  parentIdentifier: string
  identifier: string
  isVisible: boolean
  primaryFieldSchemeIdentifier: string
  secondaryFieldSchemeIdentifier: string
  showInMenu: true
  usedForCommunication: boolean
  usedForMail: boolean
  title: string
  type: `${ESchemeTypes}`
  userAbilities: `${EUserAbilities}`[]
  isParentObjectRequired?: boolean

  smartListsCount: number
  stageFieldsCount: number
}

export type IGetSchemasData = ISchemaInfo[]

export type EmailValue = string | string[] | undefined | null
export type PhoneValue = string | string[] | undefined | null
